type DataItemType = {
  dataKey: string;
  nameKey: string;
};

export const addPercentToItems = (
  data: DataItemType[]
): Array<DataItemType & { percent: number }> => {
  const total = data.reduce((sum, item) => sum + Number(item.dataKey), 0);

  return data.map((item) => {
    const numericKey = Number(item.dataKey);
    const percent = total === 0 ? 0 : (numericKey / total) * 100;

    return {
      ...item,
      percent: +percent.toFixed(2)
    };
  });
};
